import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import SubMenuView from '../../views/subMenuView';
import LoadConfig from './load-config';
import SetDeviceTag from './set-deviceTN';
import TimeZone from './timezone';

function TimeDate() {
  const yesNoItem = [
    {id: 1, name: 'Yes', component: <TimeZone />},
    {id: 2, name: 'No', component: <SetDeviceTag />},
  ];

  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  return (
    <SubMenuView
      title="Time and Date"
      menuItems={yesNoItem}
      isMenuDisabled
      content="Do you want to set the time and date?"
      onLeftCallback={() => onComponent(<LoadConfig />)}
    />
  );
}
export default TimeDate;
